import Bars3Icon from '@heroicons/react/24/solid/Bars3Icon';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

import { useUiStore } from '@/store/ui/ui.store';
import {
  Alert,
  AlertTitle,
  Avatar,
  // Badge,
  Box,
  IconButton,
  Stack,
  SvgIcon,
  // Tooltip,
  alpha,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import AccountPopover from './AccountPopover';
import MenuNotification from './MenuNotification';
import { useAuthStore } from '@/store/auth';
import { useFetchNotificacion } from '@/shared/actions/erp';
import { useSystemParamsStore } from '@/store/erp';
import MenuTicketClienteSoporteContrato from '../../erp/ticketSoporte/MenuTicketClienteSoporteContrato';

const SIDE_NAV_WIDTH = 280;
const TOP_NAV_HEIGHT = 64;

export type TopNavProps = {};

const TopNav: React.FC<TopNavProps> = () => {
  const setOpen = useUiStore(s => s.setOpenNav);
  const openNav = useUiStore(s => s.openNav);
  const openPopover = useUiStore(s => s.openPopover);
  const setOpenPopover = useUiStore(s => s.setOpenPopover);
  const [openAlert, setOpenAlert] = useState(false);

  //const [open, setOpen] = useState(true);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const accountPopoverAnchorRef = useRef(null);

  const lgUp = useMediaQuery(theme => (theme as any).breakpoints.up('lg'));

  const user = useAuthStore(s => s.user);

  const { data: dataNotificacion, isLoading: isLoadingNotificacion } = useFetchNotificacion(true, {
    visto: false,
    page_size: 3,
    page: page,
    username: user?.username
  });


  ///*Store
  const mantenimiento = useSystemParamsStore(s => s.mantenimiento);

  useEffect(() => {
    setOpenAlert(mantenimiento?.alerta_notificacion ?? false);
  }, [mantenimiento])

  return (
    <>
      <Box
        component="header"
        sx={{
          height: '10vh',
          backdropFilter: 'blur(6px)',
          backgroundColor: theme =>
            alpha(theme.palette.background.default, 0.8),
          position: 'sticky',
          left: {
            lg: `${openNav ? 0 : SIDE_NAV_WIDTH}px`,
          },
          top: 0,
          width: {
            lg: `calc(100% - ${openNav ? 0 : SIDE_NAV_WIDTH}px)`,
          },
          [!openNav ? 'transition' : '']: 'width .5s ease',
          zIndex: theme => theme.zIndex.appBar,
        }}
      >

        {openAlert && (
          <Alert
            severity="info"
            sx={{
              height: '100px',
              display: 'flex',
              alignItems: 'center',
            }}
            onClose={() => setOpenAlert(false)}
          >
            <AlertTitle>{mantenimiento?.titulo}</AlertTitle>
            {mantenimiento?.subtitulo}
          </Alert>
        )}

        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{
            minHeight: TOP_NAV_HEIGHT,
            px: 2,
          }}
        >

          <Stack alignItems="center" direction="row" spacing={2}>
            {/* ======= hamburger icon - toggle sidenav ======= */}


            <IconButton onClick={() => setOpen(!openNav)}>
              <SvgIcon fontSize="medium">
                {lgUp && (
                  openNav ? <Bars3Icon /> : <MenuOpenIcon />
                )
                }
                {!lgUp && (<Bars3Icon />)}
              </SvgIcon>
            </IconButton>


            {/* ======= search icon ======= */}
            {/* <Tooltip title="Search">
              <IconButton>
                <SvgIcon fontSize="small">
                  <MagnifyingGlassIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip> */}
          </Stack>

          <Stack alignItems="center" direction="row" spacing={1}>
            {/* <Tooltip title={''}>
              <IconButton size='medium'
                onClick={() => {
                  mode == 'light' ? setMode('dark') : setMode('light')
                }}
              >
                <SvgIcon fontSize="large">
                  {
                    mode == 'light' ?
                      <DarkModeIcon /> :
                      <LightModeIcon />
                  }
                </SvgIcon>
              </IconButton>
            </Tooltip> */}

            {/* <Tooltip title="">
              <IconButton
                onClick={() => { }}
              >
                <SvgIcon sx={{ fontSize: '30px' }}>
                  <DarkModeIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip> */}
            
            {/* BUSCAR TICKETS POR CEDULA */}
            <MenuTicketClienteSoporteContrato/>

            {/* MENU NOTIFICACION  */}

            <div style={{ margin: '0px 20px' }}>
              <MenuNotification
                key={'notificacion-topnav'}
                dataNotificacion={dataNotificacion}
                isLoadingNotificacion={isLoadingNotificacion}
                maxPage={maxPage}
                setMaxPage={setMaxPage}
                setPage={setPage}
                page={page}
              />
            </div>

            <Avatar
              onClick={() => setOpenPopover(true)}
              ref={accountPopoverAnchorRef}
              sx={{
                cursor: 'pointer',
                height: 40,
                width: 40,
              }}
              src="/assets/avatars/avatar-anika-visser.png"
            />
          </Stack>
        </Stack>
      </Box>

      <AccountPopover
        anchorEl={accountPopoverAnchorRef.current}
        open={openPopover}
        onClose={() => setOpenPopover(false)}
      />
    </>
  );
};

export default TopNav;